var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3888 18.7272H1.5",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0552 18.7272H18.833",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6109 20.9999C17.8382 20.9999 18.8331 19.9824 18.8331 18.7272C18.8331 17.472 17.8382 16.4545 16.6109 16.4545C15.3836 16.4545 14.3887 17.472 14.3887 18.7272C14.3887 19.9824 15.3836 20.9999 16.6109 20.9999Z",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61109 10.5454H1.5",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0556 10.5454H9.05566",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83305 12.8181C8.06034 12.8181 9.05526 11.8006 9.05526 10.5454C9.05526 9.29023 8.06034 8.27271 6.83305 8.27271C5.60576 8.27271 4.61084 9.29023 4.61084 10.5454C4.61084 11.8006 5.60576 12.8181 6.83305 12.8181Z",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0555 3.27271H1.5",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2779 5.54543C20.5052 5.54543 21.5001 4.5279 21.5001 3.27272C21.5001 2.01753 20.5052 1 19.2779 1C18.0506 1 17.0557 2.01753 17.0557 3.27272C17.0557 4.5279 18.0506 5.54543 19.2779 5.54543Z",
    stroke: "#51CCB8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.15c0abb88de4c501eec9c2e565d32cc6.svg";
export { ForwardRef as ReactComponent };